export default "__VITE_ASSET__302668c2__"